import React, { Component } from 'react';
import { Button, Grid } from 'semantic-ui-react'
import './Home.css';
import { authContext, getToken } from '../adalConfig';
import { connect } from 'react-redux';
import { authAxios } from '../utils';
import { GetUserURL } from '../constants';
import { bindActionCreators } from 'redux';
import { actionCreators } from '../store/Valid';
import DualHeader from './DualHeader.js';
import DualFooter from './DualFooter.js';

import Win11Header from './Win11Header.js';
import Win11 from '../img/Banner1200x221_W11.png';

import {
    msalApp,
    requiresInteraction,
    fetchMsGraph,
    isIE,
    GRAPH_ENDPOINTS,
    GRAPH_SCOPES,
    GRAPH_REQUESTS
} from "../auth-util";

// If you support IE, our recommendation is that you sign-in using Redirect APIs
const useRedirectFlow = isIE();
// const useRedirectFlow = true;

let loginNameWithDomain = authContext.getCachedUser() ? authContext.getCachedUser().profile.upn : '';
let name = authContext.getCachedUser() ? authContext.getCachedUser().profile.name : '';
class HomeGerman extends Component {
    constructor(props) {
        super(props)
        this.handleGoToHelp = this.handleGoToHelp.bind(this);
    }
    state = {
        apiResponse: '',
        redirect: false,
        errorredirect: false,
        loading: true,
    };

    handleClickFrench = async () => {
        var email = authContext.getCachedUser() ? authContext.getCachedUser().profile.upn : '';
        authAxios.post(GetUserURL, {
            LoginNameWithDomain: email
        })
            .then(response => {
                if (response.data.isAdmin) {
                    this.props.history.push('./WelcomePage')
                }
                else if (response.data.isSubmitted) {
                    this.props.history.push('./review')
                }
                else if (response.data.isOptout) {
                    this.props.history.push('./reviewOptOut')
                }
                else if (response.data.isDeadline) {
                    this.props.history.push('./DeadlinePage')
                }
                else {
                    this.props.history.push('./HomeFrench');
                }

            })
            .catch((error) => {
                console.log('error ' + error);
                this.setState({
                    errorredirect: true
                });
                this.setState({
                    loading: false
                })
                this.props.history.push('./unauthorized');
            });
    }

    handleClickEnglish = async () => {
        var email = authContext.getCachedUser() ? authContext.getCachedUser().profile.upn : '';
        authAxios.post(GetUserURL, {
            LoginNameWithDomain: email
        })
            .then(response => {
                if (response.data.isAdmin) {
                    this.props.history.push('./WelcomePage')
                }
                else if (response.data.isSubmitted) {
                    this.props.history.push('./review')
                }
                else if (response.data.isOptout) {
                    this.props.history.push('./reviewOptOut')
                }
                else if (response.data.isDeadline) {
                    this.props.history.push('./DeadlinePage')
                }
                else {
                    this.props.history.push('./');
                }

            })
            .catch((error) => {
                console.log('error ' + error);
                this.setState({
                    errorredirect: true
                });
                this.setState({
                    loading: false
                })
                this.props.history.push('./unauthorized');
            });
    }

    handleClick = async () => {
        var email = authContext.getCachedUser() ? authContext.getCachedUser().profile.upn : '';
        authAxios.post(GetUserURL, {
            LoginNameWithDomain: email
        })
            .then(response => {
                if (response.data.isAdmin) {
                    this.props.history.push('./WelcomePage')
                }
                else if (response.data.isSubmitted) {
                    this.props.history.push('./review')
                }
                else if (response.data.isOptout) {
                    this.props.history.push('./reviewOptOut')
                }
                else if (response.data.isDeadline) {
                    this.props.history.push('./DeadlinePage')
                }
                else {
                    this.props.history.push('./EmeaUserinformation');
                }
               
            })
            .catch((error) => {
                console.log('error ' + error);
                this.setState({
                    errorredirect: true
                });
                this.setState({
                    loading: false
                })
                this.props.history.push('./unauthorized');
            });
    }

    handleOptOut = async () => {
        var email = authContext.getCachedUser() ? authContext.getCachedUser().profile.upn : '';
        authAxios.post(GetUserURL, {
            LoginNameWithDomain: email
        })
            .then(response => {
                if (response.data.isSubmitted) {
                    this.props.history.push('./review')
                }
                else if (response.data.isOptout) {
                    this.props.history.push('./reviewOptOut')
                }
                else if (response.data.isDeadline) {
                    this.props.history.push('./DeadlinePage')
                }
                else {
                    this.props.history.push('./optout');
                }
                //else if (JSON.stringify(response.data.userRole).includes('CORPORATE')) {
                //    this.props.history.push('/corpuserinfo'); 
                //}
            })
            .catch((error) => {
                console.log('error ' + error);
                this.setState({
                    errorredirect: true
                });
                this.setState({
                    loading: false
                })
                this.props.history.push('./unauthorized');
            });
    }

    handleGoToHelp() {
        this.props.history.push('./help');
    }

    renderRedirect = () => {
        if (this.state.redirect) {
        }
    }

    handleWindowCallback(hash) {
        console.log('hello world');
    }
        
    componentDidMount () {

        //var email = authContext.getCachedUser() ? authContext.getCachedUser().profile.upn : '';
        //clear cookie if it exists to prevent firewall issues.
        document.cookie = "invoca_sesssion=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";     
        //document.cookie = "ARRAffinity=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";


        if (!getToken()) {
            authContext.login();
        }
        if (getToken()) {

        }

    }

    isCallback = authContext.isCallback(window.location.hash);
    if (isCallback) {
        authContext.handleWindowCallback();
    }
    
    render() {
        return (
            <div className='outer-container'>
                <Button compact className="Rlagbuttonuser" onClick={this.handleClickFrench}>Fran&ccedil;ais</Button><Button compact className="Llagbuttonuser" onClick={this.handleClickEnglish}>English</Button>
                <div className='inner-container'>
                    <DualHeader />
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={3}>
                            </Grid.Column>
                            {/*<Grid.Column width={5}>*/}
                            {/*    <Win11Header />*/}
                            {/*</Grid.Column>*/}
                            {/*<Grid.Column classname="win11" width={6}>*/}
                            {/*    <h2 className="h3win11">Has arrived!</h2>*/}
                            {/*</Grid.Column>*/}
                        </Grid.Row>
                    </Grid>

                    <div className="maindivHome">
                  
                            <p className="h1aHome">
                                Willkommen auf der Website zur<br />
                                Registrierung von Computer-Upgrades!
                            </p>
                            <p className='h3home'>
                                Diese Website f&uuml;hrt dich durch dein Computer-Upgrade und die Auswahl eines Termins. <br />
                                Sobald der Vorgang abgeschlossen ist, bekommst du eine Best&auml;tigungs-E-Mail.
                            </p>
                        <Grid>
                            <Grid.Row centered>
                                <Button
                                    type='button'
                                    //onClick={() => { history.push('./UserInformation') }}
                                    onClick={this.handleClick}
                                        className="homebegin"
                                    >
                                    Anfang
                                </Button>
                            </Grid.Row>
                            <Grid.Row centered>

                                    <Button onClick={this.handleGoToHelp} className="homehelp">Hilfe</Button>

                                    <Button onClick={this.handleOptOut} className="homeoptout">Ablehnen</Button>

                            </Grid.Row>
                        </Grid>
                      

                    </div>
                   
                </div>
                <DualFooter/>
            </div>
        );
    }
}


export default connect()(HomeGerman);


